import { useQuery } from '@apollo/client'

import { reportClientError } from '../../../../../app/_components/chrome/scripts/DataDogRumScript'
import { FETCH_COMPLETE_THE_SET } from '../../../../../lib/graphql/queries'
import { ProductWithAvailability } from '../../../../../types/graphql'

interface ProductDetails {
  loading: boolean
  product: ProductWithAvailability | null | undefined
}

const useFetchCompleteTheSet = (productHandle: string, skip: boolean): ProductDetails => {
  const { data, loading } = useQuery<{
    product?: ProductWithAvailability
  }>(FETCH_COMPLETE_THE_SET, {
    onError: error => {
      reportClientError({
        error,
        context: {
          scope: 'Complete The Set Section',
        },
      })
    },
    skip,
    variables: { handle: productHandle },
  })
  const product = data?.product?.completeTheSet

  return {
    loading,
    product,
  }
}

export default useFetchCompleteTheSet
